import { headers } from './requestConfig';
import {
  trainingTeams,
  trainingOffer,
  trainingData,
  trainingAcceptOffer,
  trainingRejectOffer,
  trainingCancelOffer,
} from '../service/links';

export const getTrainingTeams = async () => {
  const response = await fetch(trainingTeams, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
  return response;
};

export const sendTrainingOffer = async (opponent) => {
  const response = await fetch(trainingOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      opponent,
    }),
  });
  return response;
};

export const getTrainingData = async () => {
  const response = await fetch(trainingData, {
    method: 'GET',
    headers,
    credentials: 'include',
  });
  return response;
};

export const acceptTrainingOffer = async (offer) => {
  const response = await fetch(trainingAcceptOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ offer }),
  });
  return response;
};

export const rejectTrainingOffer = async (offer) => {
  const response = await fetch(trainingRejectOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ offer }),
  });
  return response;
};

export const cancelTrainingOffer = async (offer) => {
  const response = await fetch(trainingCancelOffer, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({ offer }),
  });
  return response;
};
